<script setup>
import { formatDateToCustomText } from "@/utilities/helpers";
import { StatusEnum, StatusEsgCommentEnum } from "@/utilities/enum";
import { cloneDeep } from "lodash";
</script>
<template>
  <div
    class="p-2 rounded"
    :class="[
      comment?.status === StatusEsgCommentEnum.SOLVED
        ? 'bg-gray-200'
        : 'shadow-sm bg-white',
    ]"
  >
    <div class="flex justify-between items-center mb-2">
      <div class="flex justify-start items-center gap-2">
        <img
          src="../../../assets/icon/profile.png"
          alt="profile"
          class="w-7 h-auto rounded-full"
        />
        <div class="max-w-36 overflow-hidden">
          <h4 class="font-medium text-xs truncate">
            {{ comment?.created_by ?? "-" }}
          </h4>
          <h6 class="font-normal text-[10px] text-gray-400 truncate">
            {{
              comment?.updated_at
                ? formatDateToCustomText(comment.updated_at)
                : "-"
            }}
          </h6>
        </div>
      </div>
      <div class="flex gap-3 items-center">
        <div
          class="px-2 py-0 flex gap-1 items-center bg-slate-50 rounded-lg"
          v-if="comment?.status === StatusEsgCommentEnum.SOLVED"
        >
          <h6 class="text-[10px] text-stone-600 font-medium">Solved</h6>
          <i class="mdi mdi-check-circle text-stone-400"></i>
        </div>
        <img
          v-else
          src="../../../assets/icon/check.png"
          alt="check"
          class="w-3 h-auto"
          :class="[
            status === StatusEnum.WAITING_APPROVAL && isPjo
              ? 'cursor-pointer'
              : 'cursor-not-allowed',
          ]"
          @click="
            status === StatusEnum.WAITING_APPROVAL && isPjo
              ? solvedComment(comment?.id)
              : ''
          "
        />
        <v-menu
          v-if="
            isPjo &&
            (comment?.status === StatusEsgCommentEnum.DRAFT ||
              comment?.status === StatusEsgCommentEnum.NEED_REVISION) &&
            status === StatusEnum.WAITING_APPROVAL
          "
        >
          <template v-slot:activator="{ props }">
            <i v-bind="props" class="mdi mdi-dots-vertical cursor-pointer"></i>
          </template>
          <v-list class="py-0 w-36 bg-white">
            <v-list-item
              class="hover:bg-slate-50 cursor-pointer px-3 py-1 font-medium text-xs"
              @click="editComment(comment?.id)"
            >
              Edit
            </v-list-item>
            <v-list-item
              class="hover:bg-slate-50 cursor-pointer px-3 py-1 font-medium text-xs"
              @click="deleteComment(comment?.id)"
            >
              Delete
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <p class="font-normal text-xs" v-if="!comment?.edit">
      {{ comment?.message ?? "-" }}
    </p>
    <v-form ref="formEditComment" v-else>
      <v-textarea
        variant="outlined"
        density="compact"
        :id="'edit_comment_' + comment?.id"
        auto-grow
        rows="2"
        :rules="formValidasi.message"
        v-model="message"
        class="custom-textarea text-stone-800"
        :ref="'commentTextarea_' + comment?.id"
      ></v-textarea>
      <div class="grid grid-cols-2 gap-3 items-center">
        <v-btn
          size="small"
          class="w-full capitalize"
          variant="outlined"
          id="cancel_comment"
          @click="cancelComment()"
        >
          Batal
        </v-btn>
        <v-btn
          size="small"
          class="w-full capitalize bg-red-700 text-white"
          variant="tonal"
          @click="updateComment(comment?.id)"
        >
          Simpan
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "CardCommentComponent",
  data() {
    return {
      message: null,
    };
  },
  props: {
    comment: Object,
    formValidasi: Object,
    deleteComment: Function,
    solvedComment: Function,
    isPjo: Boolean,
    status: String,
  },
  methods: {
    formatDateToCustomText,
    editComment(id) {
      this.message = cloneDeep(this.comment?.message);
      this.$emit("edit-comment", id);
    },
    cancelComment() {
      this.message = null;
      this.$emit("cancel-comment");
    },
    async updateComment(id) {
      const formData = await this.$refs.formEditComment.validate();
      if (formData.valid) {
        this.$emit("update-comment", id, this.message);
      }
    },
  },
};
</script>

<style scoped>
.custom-textarea :deep(textarea) {
  font-size: 12px !important;
  padding: 5px !important;
}
</style>
